
var activeClass  = 'is-active';
var supportClass = 'is-supported';

var defaultConfig = {
  fileSizeLimit: 5,
  draggableText: "Drag & drop here",
  fileSizeText:  "Max"
};

var SUPPORT_FILEREADER = 'FileReader' in window;
var SUPPORTED = SUPPORT_FILEREADER;


//
// Image Uploader
//
// Will try to generate an image preview for a chosen file.
//

module.exports = function ImageUploaderWidget ($host, config) {

  // Dom

  var dom = {
    main:  $($host),
    image: $('[data-image-preview-section]', $host),
    icon:  $('[data-image-preview]', $host),
    limit: $('[data-file-size-label]', $host),
    input: $('input[type="file"]', $host),
    clear: $('[data-image-clear]', $host)
  };

  var config = cloneMerge(defaultConfig, config);


  // Helpers

  function showFiles ($someDiv, files) {
    $.each(files, function (index, file) {
      $someDiv.append(img);
    });
  }

  function fileSizeTemplate () {
    return config.fileSizeText + ' ' + config.fileSizeLimit + 'MB';
  }

  function onFileChosenShowThumb (e) {
    var files = e.target.files;
    dom.icon.html('');

    if (files.length) {
      genThumbnailIn(files[0], dom.icon);
    }
  }

  function genThumbnailIn (file, $parent) {
    var img = document.createElement('img');
    $parent.append(img);
    img.onload = function () { window.URL.revokeObjectURL(this.src); };
    img.src = window.URL.createObjectURL(file);
  }

  function clearInputs () {
    dom.icon.html('');
    dom.input.val('');
  }


  // Listeners

  dom.input.on('change', onFileChosenShowThumb);
  dom.clear.on('click', clearInputs);


  // Init

  dom.limit.text(fileSizeTemplate());

}

